import { motion } from "framer-motion";
import { useLanguage } from "../lib/LanguageContext";

export default function Manifesto() {
  const { t } = useLanguage();
  return (
    <section id="manifesto" data-testid="manifesto-section" className="bg-paper py-28 md:py-40">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.25 }} transition={{ duration: 1.1 }}
          className="md:col-span-5">
          <div className="aspect-[4/5] overflow-hidden">
            <img src="/catalog/img2.jpg" alt="Amaranto — Quiénes somos" className="w-full h-full object-cover" />
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }} transition={{ duration: 1.1, delay: 0.15 }}
          className="md:col-span-7 md:pl-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-px bg-warmbrown" />
            <span className="eyebrow">{t.manifesto.eyebrow}</span>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-ink mb-10">
            {t.manifesto.title}
          </h2>
          <p className="font-body text-base md:text-lg leading-loose text-ink-soft max-w-xl">
            {t.manifesto.body}
          </p>

          <div className="mt-12 grid sm:grid-cols-3 gap-8 border-t border-cream-300 pt-8">
            {t.manifesto.pillars.map((p, i) => (
              <div key={i}>
                <p className="eyebrow text-dustyrose-deep">{`0${i + 1}`}</p>
                <p className="font-serif text-xl text-ink mt-3">{p.k}</p>
                <p className="font-body text-sm italic text-ink-soft mt-2">{p.v}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
